import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

import './inputPassword.css';

/**
 * Composante InputPassword permettant de gérer les champs de types password dans l'application
 * Features:
 * - Icone "oeil" pour révéler (pendant 1 seconde par defaut) ou cacher le mot de passe 
 * - Indicateur de capsLock lorsque la touche est enfoncée
 */
class InputPassword extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onRevealIconClick = this.onRevealIconClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.field = null;
        this.revealTimeout = null;

        this.state = {
            visible: false,
            capsLock: false,
            focused: false
        };
    }

    get labels() {
        return chainesLocales['InputPassword'][this.props.lang];
    }

    componentDidMount() {
        if (this.props.focus) {
            this.field.focus();
        }
    }

    /**
     * Si le mot de passe est révélé, il faut le laisser afficher la durée en milliseconde de spécifié dans le props.revealTimeout
     */
    componentDidUpdate() {
        if (this.props.revealTimeout > 0 && this.state.visible === true) {
            this.revealTimeout = setTimeout(() => this.setState({ visible: false }), this.props.revealTimeout);
        }
    }

    /**
     * S'assurer de clearé le timeout au unmount, s'il y a lieu
     */
    componentWillUnmount() {
        if (this.revealTimeout) {
            clearTimeout(this.revealTimeout);
        }   
    }

    render() {
        let renderInvalidMessage = this.props.invalidMessage || this.labels.invalidMsgPwd;

        return (
            <div className="InputPassword">
                <input ref={(e) => this.field = e} id={this.props.id} onFocus={this.onFocus} type={this.state.visible ? 'text': 'password'} onKeyDown={this.onKeyDown} onBlur={this.onBlur} autoCapitalize="off" className={`form-control ${this.props.isInvalid ? 'is-invalid' : ''} ${this.props.className || ''}`} value={this.props.value} onChange={this.onChange} />
                {
                    (this.props.showRevealIcon && this.props.value && this.props.value.length > 0) ? <div className={`fa toggleVisibility ${this.state.visible ? 'visible' : ''}`} onClick={this.onRevealIconClick} title={this.state.visible ? this.labels.labelHidePwd : this.labels.labelShowPwd} /> : null
                }
                {
                    (this.state.capsLock && this.props.value && this.props.value.length > 0 ) ? <small className="form-text text-muted"><span className="fa fa-exclamation-circle pr-2 text-warning" />{this.labels.labelCapsLock}</small> : null
                }
                <div className="invalid-feedback">{renderInvalidMessage}</div>
                {this.props.showHelp ? <small className="form-text text-muted">{this.props.helpMessage}</small> : null}
            </div>
        );
    }

    /**
     * Sur la touche d'un clavier un regarde si les lettres majuscules sont actives. Si c'est le cas on affiche l'indicateur de majuscules
     * @param {KeyboardEvent} e 
     */
    onKeyDown(e) {
        this.setState({ capsLock: e.getModifierState("CapsLock") });
    }

    /**
     * Sur le click de l'icone "oeil" pour reveler le mot de passe, on alterne entre le type password et text
     * @param {MouseEvent} e 
     */
    onRevealIconClick(e) {
        if (this.revealTimeout) {
            clearTimeout(this.revealTimeout);
        }

        this.setState({ visible: !this.state.visible });
    }

    /**
     * Sur le focus du champ, on change affiche l'indicateur "oeil" s'il y a lieu
     * @param {FocusEvent} e 
     */
    onFocus(e) {
        this.setState({ focused:true });
    }

    /**
     * Enlever l'indicateur de caps lock  sur la perte de focus, s'il y a lieu
     * @param {FocusEvent} e 
     */
    onBlur(e) {
         this.setState({ capsLock: false });
    }

    onChange(e) {
        //Appel du listener parent
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }
}

InputPassword.defaultProps = {
    showRevealIcon: true,
    revealTimeout: 1000, // 1 seconde
    focus: false,
    lang: 'FR',
    isInvalid: false,
    showHelp: false,
    invalidMessage: '',
    helpMessage: ''
};

InputPassword.propTypes = {
    showRevealIcon: PropTypes.bool,
    onChange: PropTypes.func,
    id: PropTypes.string,
    value: PropTypes.string.isRequired,
    lang: PropTypes.oneOf(['FR','AN', 'CR', 'CS']),
    focus: PropTypes.bool,
    revealTimeout: PropTypes.number,
    invalidMessage: PropTypes.string,
    helpMessage: PropTypes.string,
    isInvalid: PropTypes.bool,
    showHelp: PropTypes.bool
};

export default InputPassword;